<div class="mat-drawer-transition" *ngIf="sidenavOpened">
    <div class="mat-drawer-backdrop mat-drawer-shown custom-backdrop"></div>
</div>

<mat-drawer #usersSelectorPanel class="users-confirm-sidenav" position="end" mode="over" disableClose="true" [opened]="sidenavOpened">
    <ng-container *ngIf="sidenavOpened">
        <div class="panel-header mb-16">
            <div class="h-56 d-flex justify-content-between align-items-center px-16">
                <h6 class="m-0">Selected Members</h6>
        
                <div class="mb-2">        
                    <button 
                        mat-icon-button 
                        (click)="closePanel()" 
                        [matTooltip]="'Close'" 
                        [matTooltipPosition]="'below'"
                    >
                        <mat-icon class="material-icons-outlined">close</mat-icon>
                    </button>
                </div>
            </div>
        
            <mat-divider></mat-divider>
        </div>
    
        <div class="panel-content px-20 mb-16">

            <ng-container *ngIf="data?.length; else noSelectedDataTemp">
                <div class="mat-subtitle-1 text-hint mb-4">Members ({{data?.length}})</div>
        
                <div class="d-flex flex-column">
                    <mat-checkbox 
                        *ngFor="let row of data" 
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selectionData.toggle(row) : null"
                        [checked]="isSelectedItem(row)"
                        style="
                            height: 40px;
                            display: flex;
                            align-items: center;
                            width: 100%;
                            padding-left: 4px;
                            margin-bottom: 8px;
                        ">
                        <div class="d-flex flex-column" style="width: 240px;">
                            <div 
                                class="text-truncate"
                                *ngIf="showTitleValue(row) as _titleValue"
                                [matTooltip]="_titleValue" 
                                [matTooltipShowDelay]="tooltipDelay" 
                                [matTooltipPosition]="'below'"
                            >
                                {{_titleValue}}
                            </div>
                            <div 
                                class="mat-caption text-hint text-truncate" 
                                *ngIf="showSubtitleValue(row) as _subtitleValue"
                                [matTooltip]="_subtitleValue" 
                                [matTooltipShowDelay]="tooltipDelay" 
                                [matTooltipPosition]="'below'"
                            >
                                {{(_subtitleValue == 'null') ? viewKeys.subAlt : _subtitleValue }}
                            </div>
                        </div>
                    </mat-checkbox>
                </div>
            </ng-container>

            <ng-template #noSelectedDataTemp>
                <div *ngIf="noSelectedDataNote" class="mat-subtitle-2 text-hint">{{noSelectedDataNote}}</div>
            </ng-template>

        </div>

        <div class="panel-footer">
            <mat-divider></mat-divider>
            <button 
                (click)="clearAllRow()" 
                [disabled]="!data?.length" 
                mat-button 
                [color]="!data?.length ? '' : 'accent'"
            >CLEAR ALL
            </button>
        </div>

    </ng-container>    
</mat-drawer>